




































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { JinroPlayerDocument, JinroGameDocument } from "@/services/datatypes";
import { JinroRoles } from "@/services/jinro-roles";
import Jinro from "./Night/NightEachRoles/Jinro.vue";

@Component
export default class PlayerNameList extends Vue {
  @Prop() readonly survivors!: Array<JinroPlayerDocument>;
  @Prop() readonly killedPlayers!: Array<JinroPlayerDocument>;
  @Prop() readonly killedPlayersByJinro!: Array<JinroPlayerDocument>;

  beenKilledByJinroAttack(playerId: string): boolean {
    if (!this.killedPlayersByJinro) {
      return false;
    }
    const killedPlayersByJinro = this.killedPlayersByJinro as Array<
      JinroPlayerDocument
    >;
    const included = killedPlayersByJinro.find(player => {
      return player.id === playerId;
    });
    return included ? true : false;
  }
}
